import script from "./ImagesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesSection.vue?vue&type=script&setup=true&lang=js"

import "./ImagesSection.vue?vue&type=style&index=0&id=5c89ac8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c89ac8e"]])

export default __exports__